import React, { useState } from 'react';
import { Check, X, Sparkles, Shield, Users, User, Star } from 'lucide-react';
import { Link } from 'react-router-dom';
import { TopBar } from '../components/TopBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function PricingPage() {
  const [isAnnual, setIsAnnual] = useState(true);
  return <div className="flex flex-col min-h-screen w-full font-inter bg-white" data-id="element-4106">
      <TopBar data-id="element-4107" />
      <Header data-id="element-4108" />

      {/* Hero Section */}
      <section className="w-full bg-white py-16 md:py-24 border-b border-gray-200" data-id="element-4109">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center" data-id="element-4110">
          <h1 className="text-4xl md:text-6xl font-extrabold text-[#111111] mb-6 leading-tight" data-id="element-4111">
            Honest pricing. No games.
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-4112">
            No upsells. No confusing tiers. No fear-mongering. One price gets
            your whole family guided, protected, and on track.
          </p>

          {/* Monthly/Annual Toggle */}
          <div className="mt-12 flex items-center justify-center space-x-4" data-id="element-4113">
            <span className={`text-lg font-medium ${!isAnnual ? 'text-[#111111]' : 'text-gray-500'}`} data-id="element-4114">
              Monthly
            </span>
            <button onClick={() => setIsAnnual(!isAnnual)} className="relative w-16 h-8 bg-#[631bb7] rounded-full p-1 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-#[631bb7]" data-id="element-4115">
              <div className={`w-6 h-6 bg-white rounded-full shadow-md transform transition-transform duration-200 ease-in-out ${isAnnual ? 'translate-x-8' : 'translate-x-0'}`} data-id="element-4116" />
            </button>
            <span className={`text-lg font-medium ${isAnnual ? 'text-[#111111]' : 'text-gray-500'}`} data-id="element-4117">
              Annual <span className="text-[#631bb7] text-sm" data-id="element-4118">(Save 20%)</span>
            </span>
          </div>
        </div>
      </section>

      {/* Pricing Tiers */}
      <section className="w-full bg-[#f8f8f8] py-16 md:py-24" data-id="element-4119">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-4120">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start" data-id="element-4121">
            {/* Foundation (Free) */}
            <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm flex flex-col h-full" data-id="element-4122">
              <div className="mb-6" data-id="element-4123">
                <h3 className="text-2xl font-bold text-[#111111]" data-id="element-4124">
                  Foundation
                </h3>
                <p className="text-gray-500 text-sm mt-1" data-id="element-4125">
                  Essential basics for everyone
                </p>
              </div>
              <div className="mb-8" data-id="element-4126">
                <span className="text-4xl font-extrabold text-[#111111]" data-id="element-4127">
                  $0
                </span>
                <span className="text-gray-500 ml-1" data-id="element-4128">/forever</span>
              </div>
              <Link to="/onboarding" className="w-full block text-center py-3 px-4 bg-gray-100 text-[#111111] font-bold rounded-lg hover:bg-gray-200 transition-colors mb-8" data-id="element-4129">
                Start for Free
              </Link>
              <ul className="space-y-4 flex-grow" data-id="element-4130">
                <li className="flex items-start" data-id="element-4131">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4132" />
                  <span className="text-gray-700 text-sm" data-id="element-4133">For 1 person</span>
                </li>
                <li className="flex items-start" data-id="element-4134">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4135" />
                  <span className="text-gray-700 text-sm" data-id="element-4136">
                    See where you stand with a free safety checkup
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4137">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4138" />
                  <span className="text-gray-700 text-sm" data-id="element-4139">
                    Access your first critical walkthroughs
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4140">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4141" />
                  <span className="text-gray-700 text-sm" data-id="element-4142">
                    No credit card required — ever
                  </span>
                </li>
              </ul>
            </div>

            {/* Individual */}
            <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm flex flex-col h-full relative" data-id="element-4143">
              <div className="mb-6" data-id="element-4144">
                <h3 className="text-2xl font-bold text-[#111111]" data-id="element-4145">
                  Individual
                </h3>
                <p className="text-gray-500 text-sm mt-1" data-id="element-4146">
                  Full access for one person
                </p>
              </div>
              <div className="mb-8" data-id="element-4147">
                <span className="text-4xl font-extrabold text-[#111111]" data-id="element-4148">
                  {isAnnual ? '$79' : '$7.99'}
                </span>
                <span className="text-gray-500 ml-1" data-id="element-4149">
                  {isAnnual ? '/year' : '/mo'}
                </span>
                {isAnnual && <p className="text-green-600 text-sm mt-1 font-medium" data-id="element-4150">
                    Save $16/year
                  </p>}
              </div>
              <Link to="/onboarding" className="w-full block text-center py-3 px-4 bg-[#1a0647] text-white font-bold rounded-lg hover:bg-[#2d0b75] transition-colors mb-8" data-id="element-4151">
                Choose Individual
              </Link>
              <ul className="space-y-4 flex-grow" data-id="element-4152">
                <li className="flex items-start" data-id="element-4153">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4154" />
                  <span className="text-gray-700 text-sm" data-id="element-4155">For 1 person</span>
                </li>
                <li className="flex items-start" data-id="element-4156">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4157" />
                  <span className="text-gray-700 text-sm" data-id="element-4158">
                    Everything in Foundation
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4159">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4160" />
                  <span className="text-gray-700 text-sm font-semibold" data-id="element-4161">
                    Full access to all 39 guided walkthroughs
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4162">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4163" />
                  <span className="text-gray-700 text-sm" data-id="element-4164">
                    Ongoing check-ins and reminders to keep habits on track
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4165">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4166" />
                  <span className="text-gray-700 text-sm" data-id="element-4167">
                    Personalized action queue — always know what to do next
                  </span>
                </li>
              </ul>
            </div>

            {/* Family (Best Value) */}
            <div className="bg-white rounded-2xl p-8 border-2 border-[#631bb7] shadow-xl flex flex-col h-full relative transform md:-translate-y-4" data-id="element-4168">
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#631bb7] text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wide" data-id="element-4169">
                Best Value
              </div>
              <div className="mb-6 mt-2" data-id="element-4170">
                <h3 className="text-2xl font-bold text-[#111111]" data-id="element-4171">Family</h3>
                <p className="text-gray-500 text-sm mt-1" data-id="element-4172">
                  Complete protection for everyone
                </p>
              </div>
              <div className="mb-8" data-id="element-4173">
                <span className="text-4xl font-extrabold text-[#111111]" data-id="element-4174">
                  {isAnnual ? '$199' : '$19.99'}
                </span>
                <span className="text-gray-500 ml-1" data-id="element-4175">
                  {isAnnual ? '/year' : '/mo'}
                </span>
                {isAnnual && <p className="text-green-600 text-sm mt-1 font-medium" data-id="element-4176">
                    Save $40/year
                  </p>}
              </div>
              <Link to="/onboarding" className="w-full block text-center py-3 px-4 bg-[#631bb7] text-white font-bold rounded-lg hover:bg-[#521099] transition-colors mb-8 shadow-md" data-id="element-4177">
                Choose Family
              </Link>
              <ul className="space-y-4 flex-grow" data-id="element-4178">
                <li className="flex items-start" data-id="element-4179">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4180" />
                  <span className="text-gray-700 text-sm font-bold" data-id="element-4181">
                    Up to 6 people
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4182">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4183" />
                  <span className="text-gray-700 text-sm" data-id="element-4184">
                    Everything in Individual
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4185">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4186" />
                  <span className="text-gray-700 text-sm font-semibold" data-id="element-4187">
                    One dashboard to coordinate safety across your whole
                    household
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4188">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4189" />
                  <span className="text-gray-700 text-sm" data-id="element-4190">
                    Each person gets their own guided path
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4191">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4192" />
                  <span className="text-gray-700 text-sm" data-id="element-4193">
                    You can see where everyone stands — and help where needed
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4194">
                  <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-4195" />
                  <span className="text-gray-700 text-sm" data-id="element-4196">
                    No one falls through the cracks
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Lifetime Offer Section */}
      <section className="w-full bg-[#1a0647] py-16 md:py-24 relative overflow-hidden" data-id="element-4197">
        {/* Background decorative elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-4198">
          <div className="absolute top-10 left-10 w-64 h-64 bg-[#8041bf] rounded-full filter blur-3xl" data-id="element-4199"></div>
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#00f4f8] rounded-full filter blur-3xl" data-id="element-4200"></div>
        </div>

        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-4201">
          <div className="text-center mb-12" data-id="element-4202">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-4203">
              For our first 1,000 families: lifetime access at a founder's
              price.
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-4204">
              One payment. All future updates included. When we add new
              walkthroughs, new check-ins, and new protections — you get them
              automatically. This pricing goes away at 1,000 members.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-4205">
            {/* Lifetime Individual */}
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-2xl p-8 border border-white border-opacity-20 hover:bg-opacity-15 transition-all" data-id="element-4206">
              <div className="flex items-center justify-between mb-6" data-id="element-4207">
                <h3 className="text-2xl font-bold text-white" data-id="element-4208">
                  Lifetime Individual
                </h3>
                <User className="text-[#00f4f8] w-8 h-8" data-id="element-4209" />
              </div>
              <div className="mb-6" data-id="element-4210">
                <span className="text-5xl font-extrabold text-white" data-id="element-4211">$199</span>
                <p className="text-[#00f4f8] font-medium mt-2" data-id="element-4212">
                  One-Time Payment
                </p>
              </div>
              <p className="text-gray-300 mb-8" data-id="element-4213">
                Includes all future updates to the Individual Plan.
              </p>
              <button className="w-full py-4 px-6 bg-white text-[#1a0647] font-bold rounded-lg hover:bg-gray-100 transition-colors" data-id="element-4214">
                Get Lifetime Individual
              </button>
            </div>

            {/* Lifetime Family */}
            <div className="bg-gradient-to-br from-[#631bb7] to-[#521099] rounded-2xl p-8 border border-white border-opacity-20 shadow-2xl transform md:scale-105" data-id="element-4215">
              <div className="flex items-center justify-between mb-6" data-id="element-4216">
                <h3 className="text-2xl font-bold text-white" data-id="element-4217">
                  Lifetime Family
                </h3>
                <Users className="text-white w-8 h-8" data-id="element-4218" />
              </div>
              <div className="mb-6" data-id="element-4219">
                <span className="text-5xl font-extrabold text-white" data-id="element-4220">$599</span>
                <p className="text-white text-opacity-90 font-medium mt-2" data-id="element-4221">
                  One-Time Payment
                </p>
              </div>
              <p className="text-white text-opacity-80 mb-8" data-id="element-4222">
                Includes all future updates to the Family Plan for up to 6
                members.
              </p>
              <button className="w-full py-4 px-6 bg-[#00f4f8] text-[#1a0647] font-bold rounded-lg hover:bg-[#00e0e4] transition-colors shadow-lg" data-id="element-4223">
                Get Lifetime Family
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Competitive Comparison */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-4224">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-4225">
          <div className="text-center mb-12" data-id="element-4226">
            <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-4" data-id="element-4227">
              Why Overpay for Anxiety When You Can Invest in Capability?
            </h2>
          </div>

          <div className="overflow-x-auto" data-id="element-4228">
            <table className="w-full max-w-5xl mx-auto border-collapse" data-id="element-4229">
              <thead data-id="element-4230">
                <tr data-id="element-4231">
                  <th className="text-left py-4 px-6 font-bold text-gray-500 uppercase text-sm tracking-wider border-b-2 border-gray-100" data-id="element-4232"></th>
                  <th className="text-left py-4 px-6 border-b-2 border-[#631bb7]" data-id="element-4233">
                    <div className="text-xl font-bold text-[#631bb7]" data-id="element-4234">
                      Caveo
                    </div>
                  </th>
                  <th className="text-left py-4 px-6 border-b-2 border-gray-100" data-id="element-4235">
                    <div className="text-xl font-bold text-gray-600" data-id="element-4236">
                      Norton 360 / Aura
                    </div>
                  </th>
                  <th className="text-left py-4 px-6 border-b-2 border-gray-100" data-id="element-4237">
                    <div className="text-xl font-bold text-gray-600" data-id="element-4238">
                      Geek Squad
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-4239">
                {[{
                label: 'Philosophy',
                caveo: 'Gets the important things done — and keeps them done',
                competitor1: 'Sells reactive alerts & fear',
                competitor2: 'Profits from your tech breaking'
              }, {
                label: 'Cost',
                caveo: 'Starts at $7.99/mo',
                competitor1: '$12 - $35/mo',
                competitor2: '$99+ per incident'
              }, {
                label: 'Experience',
                caveo: 'Step-by-step walkthroughs anyone can follow',
                competitor1: 'Confusing technical jargon',
                competitor2: 'In-person visit required'
              }, {
                label: 'Incentive',
                caveo: 'We win when you feel confident',
                competitor1: 'They win when you stay anxious',
                competitor2: 'They win when you have problems'
              }, {
                label: 'Outcome',
                caveo: "A family that's actually protected — not just subscribed to something",
                competitor1: 'Dependency & Confusion',
                competitor2: 'A temporary fix'
              }].map((row, idx) => <tr key={idx} className={idx % 2 === 0 ? 'bg-gray-50' : 'bg-white'} data-id="element-4240">
                    <td className="py-6 px-6 font-bold text-[#111111]" data-id="element-4241">
                      {row.label}
                    </td>
                    <td className="py-6 px-6 font-medium text-[#631bb7] bg-[#631bb7] bg-opacity-5" data-id="element-4242">
                      {row.caveo}
                    </td>
                    <td className="py-6 px-6 text-gray-600" data-id="element-4243">
                      {row.competitor1}
                    </td>
                    <td className="py-6 px-6 text-gray-600" data-id="element-4244">
                      {row.competitor2}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="w-full bg-[#f8f8f8] py-16 md:py-24 border-t border-gray-200" data-id="element-4245">
        <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-4246">
          <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-12 text-center" data-id="element-4247">
            Your Questions, Answered.
          </h2>
          <div className="space-y-6" data-id="element-4248">
            {[{
            q: 'Can I cancel my subscription at any time?',
            a: 'Yes. You can cancel your monthly or annual plan at any time from your account settings. No questions asked. Your plan will remain active until the end of the current billing period.'
          }, {
            q: 'What happens when you add new modules or features?',
            a: "All new modules and feature updates are included in the Individual, Family, and Lifetime plans at no extra cost. Our platform is constantly evolving to meet new threats, and you'll always have the latest protection."
          }, {
            q: 'How does the Family Plan work for different family members?',
            a: "The Family Plan gives you a central dashboard to invite up to 5 other family members. You can use our role-based views to see different information; for example, an adult child can see their parent's progress and help them with tasks, while the parent sees a simplified view focused on their own learning."
          }, {
            q: 'Is the Free (Foundation) plan free forever?',
            a: "Yes. The Foundation plan is free forever. It's a great way to get started with our basic security assessment and introductory modules to see how Caveo works."
          }, {
            q: 'What if I’m not satisfied?',
            a: "We offer a 30-day money-back guarantee on all paid plans, including lifetime memberships. If you're not happy for any reason, just let us know within 30 days of your purchase for a full refund."
          }].map((faq, index) => <div key={index} className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm" data-id="element-4249">
                <h3 className="text-lg font-bold text-[#111111] mb-2" data-id="element-4250">
                  {faq.q}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-4251">{faq.a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-4252">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center" data-id="element-4253">
          <h2 className="text-3xl md:text-5xl font-bold text-[#111111] mb-6" data-id="element-4254">
            Start free. See what your family hasn't done yet. Upgrade whenever
            you're ready.
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-10" data-id="element-4255">
            No email required. No credit card. Just a clear picture of where you
            stand — in 3 minutes.
          </p>
          <Link to="/onboarding" className="inline-block bg-[#631bb7] text-white px-10 py-4 rounded-lg font-bold text-lg hover:bg-[#521099] transition-all shadow-lg transform hover:-translate-y-1" data-id="element-4256">
            Get Started for Free
          </Link>
        </div>
      </section>

      <Footer data-id="element-4257" />
    </div>;
}